var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockKeyhole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12156_77141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 1C8.65625 1 10 2.34375 10 4V6H4V4C4 2.34375 5.34375 1 7 1ZM3 4V6H2.5C1.11875 6 0 7.11875 0 8.5V13.5C0 14.8813 1.11875 16 2.5 16H11.5C12.8813 16 14 14.8813 14 13.5V8.5C14 7.11875 12.8813 6 11.5 6H11V4C11 1.79063 9.20938 0 7 0C4.79063 0 3 1.79063 3 4ZM2.5 7H11.5C12.3281 7 13 7.67188 13 8.5V13.5C13 14.3281 12.3281 15 11.5 15H2.5C1.67188 15 1 14.3281 1 13.5V8.5C1 7.67188 1.67188 7 2.5 7ZM7.5 9.75C7.5 9.475 7.275 9.25 7 9.25C6.725 9.25 6.5 9.475 6.5 9.75V12.25C6.5 12.525 6.725 12.75 7 12.75C7.275 12.75 7.5 12.525 7.5 12.25V9.75Z",
    fill: "#1D1F2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12156_77141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockKeyhole);
export default __webpack_public_path__ + "static/media/lock-keyhole.10ba5969c9f60ebe53a417fdbd6a60a2.svg";
export { ForwardRef as ReactComponent };